<header class="page-header">
  <div class="page-header__body">
    <h1 class="page-header__title">
      {{ headerTitle }}
      <span *ngIf="subtitle" class="page-header__subtitle">{{ subtitle }}</span>
    </h1>
    <p *ngIf="caption" class="page-header__caption">{{ caption }}</p>
  </div>
  <div class="page-header__actions">
    <ng-content select="[header-actions]"></ng-content>
  </div>
</header>
